module.exports = __webpack_public_path__ + "static/img/GR847-FCM-SDW375-BB-2.c520c01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/GR847-FCM-SDW375-BB-2.jpg
// module id = 75kp
// module chunks = 0